import { useCallback, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { ROUTESWEB } from "@repo/utils";

import AinaDoubtChatScreen from "../components/aina-doubt-chat/AinaDoubtChatScreen";
import type { GetAnswersChatSession } from "../components/doubts-dashboard/GetAnswersChat/types";
import { consumeAinaChatBootstrap } from "../lib/ainaChatBootstrap";

type LocationState = {
  ainaChatBootstrap?: GetAnswersChatSession;
};

export const AinaDoubtChatPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const storageBootstrapRef = useRef<GetAnswersChatSession | null | undefined>(
    undefined,
  );
  const locationStateBootstrap = (location.state as LocationState | null)
    ?.ainaChatBootstrap;
  if (storageBootstrapRef.current === undefined) {
    storageBootstrapRef.current = consumeAinaChatBootstrap();
  }
  const bootstrap = locationStateBootstrap ?? storageBootstrapRef.current;

  useEffect(() => {
    if (!bootstrap) {
      navigate(`/${ROUTESWEB.APP.DOUBTS}`, { replace: true });
    }
  }, [bootstrap, navigate]);

  const handleInitialAinaChatConsumed = useCallback(() => {
    navigate(location.pathname, {
      replace: true,
      state: {},
    });
  }, [location.pathname, navigate]);

  if (!bootstrap) {
    return null;
  }

  return (
    <AinaDoubtChatScreen
      initialAinaChatSession={bootstrap}
      onInitialAinaChatConsumed={handleInitialAinaChatConsumed}
    />
  );
};
